"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entities_1 = require("./entities");
exports.getOsmosysResourceName = (obj) => {
    switch (obj.constructor) {
        case entities_1.AccessKey:
            obj = obj;
            return obj.name ? `${obj.name}` : `AccessKey #${obj.id}`;
        case entities_1.ActiveCampaign:
            obj = obj;
            return obj.name ? `${obj.name}` : `ActiveCampaign #${obj.id}`;
        case entities_1.Ad:
            obj = obj;
            return obj.name ? `${obj.name}` : `Ad #${obj.id}`;
        case entities_1.AppSettings:
            obj = obj;
            return `AppSettings #${obj.id}`;
        case entities_1.CampaignMonitor:
            obj = obj;
            return obj.name ? `${obj.name}` : `CampaignMonitor #${obj.id}`;
        case entities_1.ContentConversion:
            obj = obj;
            return obj.name ? `${obj.name}` : `ContentConversion #${obj.id}`;
        case entities_1.ContentConversionStep:
            obj = obj;
            return obj.name ? `${obj.name}` : `ContentConversionStep #${obj.id}`;
        case entities_1.ContentFeed:
            obj = obj;
            return obj.name ? `${obj.name}` : `ContentFeed #${obj.id}`;
        case entities_1.ContentMapping:
            obj = obj;
            return obj.name ? `${obj.name}` : `ContentMapping #${obj.id}`;
        case entities_1.ContentSystem:
            obj = obj;
            return obj.name ? `${obj.name}` : `ContentSystem #${obj.id}`;
        case entities_1.Context:
            obj = obj;
            return obj.name ? `${obj.name}` : `Context #${obj.id}`;
        case entities_1.Email:
            obj = obj;
            return obj.name ? `${obj.name}` : `Email #${obj.id}`;
        case entities_1.EmailBase:
            obj = obj;
            return `EmailBase #${obj.id}`;
        case entities_1.EmailCampaign:
            obj = obj;
            return obj.name ? `${obj.name}` : `EmailCampaign #${obj.id}`;
        case entities_1.EmailList:
            obj = obj;
            return obj.name ? `${obj.name}` : `EmailList #${obj.id}`;
        case entities_1.EmailSegment:
            obj = obj;
            return obj.name ? `${obj.name}` : `EmailSegment #${obj.id}`;
        case entities_1.EmailTemplate:
            obj = obj;
            return obj.name ? `${obj.name}` : `EmailTemplate #${obj.id}`;
        case entities_1.EmailTemplateBlock:
            obj = obj;
            return obj.name ? `${obj.name}` : `EmailTemplateBlock #${obj.id}`;
        case entities_1.EmailTemplateVersion:
            obj = obj;
            return obj.version ? `${obj.version}` : `EmailTemplateVersion #${obj.id}`;
        case entities_1.EmailTemplateVersionDeployment:
            obj = obj;
            return `EmailTemplateVersionDeployment #${obj.id}`;
        case entities_1.HostedFile:
            obj = obj;
            return `HostedFile #${obj.id}`;
        case entities_1.Integration:
            obj = obj;
            return obj.name ? `${obj.name}` : `Integration #${obj.id}`;
        case entities_1.Mailchimp:
            obj = obj;
            return obj.name ? `${obj.name}` : `Mailchimp #${obj.id}`;
        case entities_1.Mailjet:
            obj = obj;
            return obj.name ? `${obj.name}` : `Mailjet #${obj.id}`;
        case entities_1.Organization:
            obj = obj;
            return obj.name ? `${obj.name}` : `Organization #${obj.id}`;
        case entities_1.OsmosysMessage:
            obj = obj;
            return `OsmosysMessage #${obj.id}`;
        case entities_1.Sailthru:
            obj = obj;
            return obj.name ? `${obj.name}` : `Sailthru #${obj.id}`;
        case entities_1.Salesforce:
            obj = obj;
            return obj.name ? `${obj.name}` : `Salesforce #${obj.id}`;
        case entities_1.Session:
            obj = obj;
            return `Session #${obj.id}`;
        case entities_1.TransactionalEmail:
            obj = obj;
            return `TransactionalEmail #${obj.id}`;
        case entities_1.User:
            obj = obj;
            return obj.fullName
                ? `${obj.fullName}`
                : obj.email
                    ? obj.email
                    : `User #${obj.id}`;
        case entities_1.UserInvite:
            obj = obj;
            return `UserInvite #${obj.id}`;
        case entities_1.Workflow:
            obj = obj;
            return obj.name ? `${obj.name}` : `Workflow #${obj.id}`;
        case entities_1.WorkflowRun:
            obj = obj;
            return `WorkflowRun #${obj.id}`;
        case entities_1.WorkflowRunAction:
            obj = obj;
            return `WorkflowRunAction #${obj.id}`;
        case entities_1.Workspace:
            obj = obj;
            return obj.name ? `${obj.name}` : `Workspace #${obj.id}`;
        case entities_1.WorkspaceMembership:
            obj = obj;
            return `WorkspaceMembership #${obj.id}`;
        default:
            return `Resource #${obj.id}`;
    }
};
//# sourceMappingURL=getOsmosysResourceName.js.map